var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotInstalledApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43636",
    "data-name": "Group 43636",
    transform: "translate(-1231 -4245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16140",
    "data-name": "Rectangle 16140",
    width: 16,
    height: 16,
    transform: "translate(1231 4245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "translate(1115.437 4231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M126.593,29h-6.061a.931.931,0,0,1-.931-.931V15.931a.931.931,0,0,1,.931-.931h6.061a.931.931,0,0,1,.931.931V28.069A.931.931,0,0,1,126.593,29Z",
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M194.233,15l-.436,1.627H190.86L190.424,15",
    transform: "translate(-68.766)",
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3358",
    "data-name": "Line 3358",
    x2: 2.266,
    transform: "translate(122.43 27.257)",
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16141",
    "data-name": "Rectangle 16141",
    width: 3,
    height: 18.384,
    transform: "translate(1244.439 4245.439) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3359",
    "data-name": "Line 3359",
    y1: 13,
    x2: 13,
    transform: "translate(1232.5 4246.5)",
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInstalledApp);
export default __webpack_public_path__ + "static/media/not-installed-app.f2e1e6d23b3339c24062455daf5aa898.svg";
export { ForwardRef as ReactComponent };